define('shared/remote/member/update',[
    'shared/remote/ajax',
    'shared/lib/RSVP',
    './cache',
    '../util/MemberLeadPayloadCreator'
], 
function(
    ajax, 
    RSVP,
    cache,
    MemberLeadPayloadCreator
) {
    return function(options){
        return RSVP.resolve()
            .then(function(){
                return MemberLeadPayloadCreator.instance.create(options, {noAutoRetrieve: true});
            })
            .then(function(data){
                var hasProp = false;
                for(var key in data) {
                    if (!data.hasOwnProperty(key)) {
                        continue;
                    }
                    hasProp = true;
                    break;
                }
                if (!hasProp) {
                    return RSVP.resolve();
                }
                // this field is requested by Erdem, 
                // so he can keep a track of who committed the crime
                data.RequestSource = window.location.href;
                return ajax({
                    url: '/1/api/commerce-gateway/member',
                    method: 'patch',
                    data: data
                });
            })
            .then(function(memberData){
                if (memberData) {
                    return cache.set(memberData);
                }
            });
    };
});

